import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Input, DatePicker, Select, InputNumber } from 'antd';
import { createEvent, getAllEvents } from '../../../redux/Event/actions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanies } from '../../../redux/Company/actions'; // Import fetchCompanies action
import { fetchCountries } from '../../../redux/Country/actions'; // Import fetchCountries action

const { Option } = Select;
const { TextArea } = Input;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const AddEventButton = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const users = useSelector(state => state.Users?.data || []);
  const companies = useSelector(state => state.companies?.companies || []);
  const countries = useSelector(state => state.countries?.countries || []);

  // Fetch companies and countries when the component mounts
  useEffect(() => {
    dispatch(fetchCompanies());  // Fetch companies
    dispatch(fetchCountries());  // Fetch countries
  }, [dispatch]);

  const showModal = () => {
    setVisible(true);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const hideModal_Cancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const form_onFinish = async (values) => {
    const newEvent = {
      eventname: values.eventname,
      activity: values.activity,
      user: values.user,
      company: values.company,
      country: values.country,
      location: values.location,
      description: values.description,
      emailTemplate: values.emailTemplate,
      participants: values.participants,
      status: values.status,
      cost: {
        amount: values.amount,
        currency: values.currency,
      },
      tags: values.tags ? values.tags.split(',').map(tag => tag.trim()) : [],
      dateAndTime: {
        startDateTime: values.startDate?.toISOString() || null,
        endDateTime: values.endDate?.toISOString() || null,
        timeZone: 'UTC',
      },
    };

    await dispatch(createEvent(newEvent));
    dispatch(getAllEvents());
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Créer
      </Button>
      <Modal
        title="Ajouter Event"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Valider"
        cancelText="Fermer"
      >
        <Form
          {...layout}
          name="basic"
          form={form}
          onFinish={form_onFinish}
          initialValues={{ remember: false }}
        >
          <Form.Item
            label="Name"
            name="eventname"
            rules={[{ required: true, message: 'Please input your event name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Activity"
            name="activity"
            rules={[{ required: true, message: 'Please input your activity!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Organizer"
            name="user"
            rules={[{ required: true, message: 'Please select an organizer!' }]}
          >
            <Select>
              {users.map((user) => (
                <Option key={user._id} value={user._id}>{user.username}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Company"
            name="company"
          >
            <Select placeholder="Select a company">
              {companies.map((company) => (
                <Option key={company._id} value={company._id}>{company.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: true, message: 'Please select a country!' }]}
          >
            <Select placeholder="Select a country">
              {countries.map((country) => (
                <Option key={country._id} value={country._id}>{country.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: 'Please select a start date!' }]}
          >
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: 'Please select an end date!' }]}
          >
            <DatePicker showTime />
          </Form.Item>

          <Form.Item
            label="Location"
            name="location"
            rules={[{ required: true, message: 'Please input the location!' }]}
          >
            <TextArea />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
          >
            <TextArea />
          </Form.Item>

          <Form.Item
            label="Email Template"
            name="emailTemplate"
          >
            <TextArea />
          </Form.Item>

          <Form.Item
            label="Participants"
            name="participants"
          >
            <InputNumber min={0} />
          </Form.Item>

          <Form.Item
            label="Status"
            name="status"
            rules={[{ required: true, message: 'Please select the status!' }]}
          >
            <Select>
              <Option value="scheduled">Scheduled</Option>
              <Option value="canceled">Canceled</Option>
              <Option value="completed">Completed</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Cost Amount"
            name="amount"
          >
            <InputNumber min={0} />
          </Form.Item>

          <Form.Item
            label="Currency"
            name="currency"
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Tags"
            name="tags"
          >
            <Input placeholder="Enter tags separated by commas" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddEventButton;
